<ng-container *ngIf="error$ | async as error; else noError">
    <h1 id="page-title">Error</h1>
    <p id="page-description">
        <span>{{ error.message }}</span>
    </p>
</ng-container>
<ng-template #noError>
    <p>Nem található hiba.</p>
</ng-template>